module.exports = __webpack_public_path__ + "static/media/feature-3.8571e172.png";